// app/javascript/controllers/dashboard_history_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static values = { historyId: String }

  connect() {
    console.log("✅ DashboardHistory controller connected with id:", this.historyIdValue)

    // For browser tab close / refresh
    window.addEventListener("beforeunload", this.closeSession)

    // For Turbo navigation (within app links)
    document.addEventListener("turbo:before-visit", this.closeSession)
  }

  disconnect() {
    console.log("❌ DashboardHistory controller disconnected")

    // 🚀 Ensure we also close session when controller disconnects
    this.closeSession()

    window.removeEventListener("beforeunload", this.closeSession)
    document.removeEventListener("turbo:before-visit", this.closeSession)
  }

  closeSession = () => {
    if (!this.historyIdValue) return

    console.log("📡 Closing session for history id:", this.historyIdValue)

    // Use navigator.sendBeacon for reliability on unload
    const url = "/dashboard_access/end_session"
    const data = JSON.stringify({ dashboard_history_id: this.historyIdValue })
    const headers = { type: "application/json" }

    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([data], headers))
    } else {
      fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
          "Content-Type": "application/json",
        },
        body: data
      })
    }
  }
}
